import React from "react";
import bg_video from "../../dist/img/Flowdia_Q_BG_movie.mov";
import { useLocation, Link } from "react-router-dom";

const Question1_5 = ({ deleteStep , setAnswer1_5, addStep }) => {
  const answerHandler = (option) => {
    setAnswer1_5(option);
    addStep();
  };
  return (
    <section className="c-question">
      <video poster="" autoPlay loop playsInline muted>
        <source src={bg_video} type="video/mp4"></source>
      </video>
  
      <section className="c-question__progress">
        <dl>
          <dt>QUESTION</dt>
          <dd>
            2 / <span>14</span>
          </dd>
        </dl>
      </section>

      <section class="c-question__content p-question__content p-question__content--3 c-box2">
        <h1 class="c-question__title">年齢とともに<br/>髪の変化を感じますか？</h1>
        <section
          onClick={() => answerHandler("option1")}
          class="c-question__option p-question__option p-question__option--3n"
        >
          <p>No</p>
        </section>
        <section
          onClick={() => answerHandler("option2")}
          class="c-question__option p-question__option p-question__option--3n"
        >
          <p>Yes</p>
        </section>
        <Link style ={{  margin: "25px auto"}} onClick={() => deleteStep()}  className="c-question__btn2 p-output__btn--v2">
          BACK
        </Link>
      </section>
    </section>
  );
};

export default Question1_5;
